import { Box, LoadingOverlay, ScrollArea, Stack, Text } from '@mantine/core';

import useDesktop from '@/hooks/useDesktop';

import { MENU_TEMPLATES_HEADING } from '../constants';
import type { MenuTemplateFilters as Filters, MenuTemplateSummary } from '../types';

import { MenuTemplateFilters } from './MenuTemplateFilters';
import { MenuTemplateList } from './MenuTemplateList';

type MenusRestaurantListSectionProps = {
  templates: MenuTemplateSummary[];
  loading: boolean;
  error: string;
  filters: Filters;
  onFiltersChange: (filters: Filters) => void;
  selectedTemplateId: string | null;
  onSelectTemplate: (id: string) => void;
};

export const MenusRestaurantListSection: React.FC<MenusRestaurantListSectionProps> = ({
  templates,
  loading,
  error,
  filters,
  onFiltersChange,
  selectedTemplateId,
  onSelectTemplate,
}) => {
  const isDesktop = useDesktop();

  return (
    <Stack gap={0} pos="relative" h={isDesktop ? '100%' : undefined} bg="gray.1" px="xs" py="sm">
      <LoadingOverlay visible={loading} />

      <Box
        pos="sticky"
        top={0}
        mb="sm"
        px="xs"
        pb="xs"
        style={{ borderBottom: '1px solid var(--mantine-color-gray-3)', zIndex: 1 }}
      >
        <Text size="lg" fw={700} mb="sm">
          {MENU_TEMPLATES_HEADING}
        </Text>
        <MenuTemplateFilters filters={filters} onChange={onFiltersChange} />
      </Box>
      {!loading && (
        <ScrollArea
          type="auto"
          offsetScrollbars="present"
          flex={isDesktop ? 1 : undefined}
          h={isDesktop ? '100%' : '400px'}
          mih={isDesktop ? 0 : undefined}
        >
          <MenuTemplateList
            templates={templates}
            loading={loading}
            error={error}
            filters={filters}
            onFiltersChange={onFiltersChange}
            selectedTemplateId={selectedTemplateId}
            onSelectTemplate={onSelectTemplate}
          />
        </ScrollArea>
      )}
    </Stack>
  );
};
